var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "summary" }, [
    _vm._m(0),
    _c("div", { staticClass: "row summary_row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("span", { staticClass: "summary_heading" }, [_vm._v("New updates")]),
        _c("span", { staticClass: "summary_heading_count" }, [
          _vm._v(_vm._s(_vm.regWatchUpdates.new)),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row summary_row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("span", { staticClass: "summary_heading" }, [_vm._v("All updates")]),
        _vm.regWatchUpdates.view_all
          ? _c("span", { staticClass: "summary_heading_count" }, [
              _vm._v(
                _vm._s(
                  _vm.regWatchUpdates.view_all - _vm.regWatchUpdates.archived
                )
              ),
            ])
          : _vm._e(),
      ]),
    ]),
    _c("div", { staticClass: "row summary_row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("span", { staticClass: "summary_heading" }, [
          _vm._v("Archive updates"),
        ]),
        _vm.regWatchUpdates.view_all
          ? _c("span", { staticClass: "summary_heading_count" }, [
              _vm._v(_vm._s(_vm.regWatchUpdates.archived)),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("h3", { staticClass: "title" }, [
        _c("img", {
          staticClass: "reg_watch_icon",
          attrs: { src: "/static/images/icons/reg_alerts_full_icon.svg" },
        }),
        _c("span", [_vm._v("Summary")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }